import { Navigate, Outlet, useSearchParams } from "react-router";

import { getToken } from "@/services/auth";

export function GuestRoute() {
  const [searchParams] = useSearchParams();
  const isDevPreview =
    import.meta.env.DEV && searchParams.get("preview") === "1";
  if (!isDevPreview && getToken()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
